<template>
  <div class="ly-inner">
    <idc-page-title :breadcrumbList="breadcrumbList">{{ pageTitle }}</idc-page-title>
    <div class="table-block">
      <!-- 2022.03.14 수정 -> 모달 클릭이벤트 추가 -->
      <rate-info
        :custId="custId"
        @isModal="storagePayment = true"
      ></rate-info>
      <!-- //2022.03.14 수정 -> 모달 클릭이벤트 추가 -->
    </div>
    <!-- 2022.03.14 테이블 삭제 -->
    <!-- <div class="table-blocl">
      <payment-history :svcContId="'24783891000'"></payment-history>
    </div> -->
    <!-- //2022.03.14 테이블 삭제 -->
    <!-- 2022.03.14 모달 추가 -->
    <idc-modal
      :visible.sync="storagePayment"
      :title="$t('messages.titStoragePayment')"
      width="1140px"
    >
      <template #content>
        <payment-history :svcContId="'24783891000'"></payment-history>
      </template>
    </idc-modal>
    <!-- //2022.03.14 모달 추가 -->
  </div>
</template>

<script>
import IdcPageTitle from "@/components/common/IdcPageTitle";
// 2022.03.14 추가
import IdcModal from "@/components/common/IdcModal";
import RateInfo from "@/components/idcUsageStatus/rateStatus/RateInfo";
import PaymentHistory from "@/components/idcUsageStatus/rateStatus/PaymentHistory";

export default {
  components: {
    IdcPageTitle,
    // 2022.03.14 추가
    IdcModal,
    RateInfo,
    PaymentHistory,
  },
  data() {
    return {
      // 2022.03.14 추가
      storagePayment: false,
      title : this.$route.meta.title,
      navigator : this.$route.meta.navigator
    };
  },
  computed: {
    breadcrumbList() {
      return this.navigator;
    },
    pageTitle() {
      return this.title;
    },
    custId() {
      return this.$store.getters["userInfoStore/getCustId"];
    },
    i18n() {
      return this.$i18n.locale;
    }
  },
  watch: {
    i18n(newVal) {
      this.title      = (newVal === 'ko') ? this.$route.meta.title : this.$route.meta.titleEn
      this.navigator  = (newVal === 'ko') ? this.$route.meta.navigator : this.$route.meta.navigatorEn
    }
  },
  mounted() {
    this.title      = (this.i18n === 'ko') ? this.$route.meta.title : this.$route.meta.titleEn;
    this.navigator  = (this.i18n === 'ko') ? this.$route.meta.navigator : this.$route.meta.navigatorEn;
  }
};
</script>

<style lang="scss" scoped>
.el-pagination {
  margin-top: 20px;
}

.table {
  &-header {
    text-align: left;
    padding-bottom: 20px;
  }
  &-title {
    font-size: $--font-size-large;
    color: $--color-black;
    font-weight: $--font-weight-bold;
  }
  &-count {
    text-align: left;
    font-size: $--font-size-base;
    margin-bottom: 10px;
    span {
      font-weight: $--font-weight-bold;
    }
  }
  &-block {
    padding-top: 20px;
    &:not(:last-child) {
      padding-bottom: 40px;
    }
  }
}
</style>
